module.exports = __webpack_public_path__ + "media/images/Frontpagepic-47ebf761ddd180b9a9efebd57c6b1c19.png";